import { BODY_SM_SM_STYLES } from '@constants/text.ts';
import styled from 'styled-components';

export const CardInfoDatesWrapper = styled.div`
    ${BODY_SM_SM_STYLES};
    display: flex;
    align-items: center;
    gap: 4px;
`;

export const AssignedText = styled.div`
    color: var(--colors-text-on-disabled, #70768d);
`;

export const DueText = styled.div<{
    $isCompletedOrPassed: boolean;
    $isOverdue: boolean;
}>`
    color: ${({ $isCompletedOrPassed, $isOverdue }) =>
        $isOverdue
            ? 'var(--colors-text-error, #DA1E28)'
            : $isCompletedOrPassed
              ? 'var(--colors-text-success, #22A06B)'
              : 'var(--colors-text-on-disabled, #70768d)'};
`;
